import { getTriggerItemsFromListResult } from '@/lib/automationTriggers/triggerState.js';
import isDeepEqual from '@/lib/isDeepEqual.js';
import getScopedExistingArray from '@/redux/reducers/pieveReducer/getScopedExistingArray.js';
import resolveCollectionScopeCompanyId from '@/redux/reducers/pieveReducer/resolveCollectionScopeCompanyId.js';

const replaceTriggerItemsFromRequestPayload = ({ state, payload } = {}) => {
  const nextScopeCompanyId = resolveCollectionScopeCompanyId({
    payload,
    state,
    ownerKey: 'triggerItemsScopeCompanyId'
  });
  const previousTriggerItems = getScopedExistingArray({
    items: state?.triggerItems,
    ownerCompanyId: state?.triggerItemsScopeCompanyId,
    activeCompanyId: nextScopeCompanyId
  });
  const nextTriggerItems = getTriggerItemsFromListResult(payload?.data || payload);

  if (isDeepEqual(previousTriggerItems, nextTriggerItems) && nextScopeCompanyId === (String(state?.triggerItemsScopeCompanyId || '').trim() || null)) {
    return state;
  }

  return {
    ...state,
    triggerItems: nextTriggerItems,
    triggerItemsScopeCompanyId: nextScopeCompanyId
  };
};

export default replaceTriggerItemsFromRequestPayload;
